'use strict';

angular.module('msWidgets').directive('msWidgetInputColumnSelector', [function () {
  return {
    templateUrl: 'widgets/templates/input/column_selector.html',
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
      this.isComplete = function () {
        for (var i = 0; i < $scope.widget.properties.size; i++) {
          if (angular.isUndefined($scope.boxes[i])) {
            return false;
          }
        }
        return true;
      };
    }]
  };
}]);